/* poor man's do expressions */
export function run<T>(callback: () => T): T {
  return callback()
}
